var View = require('views/base/view');

var ResourceItemView = View.extend({
  autoRender: true,
  template: require('./templates/resource-item')
});

module.exports = ResourceItemView;